import { Repository } from "./adapters/repository";

import * as createProjectStatus from "./useCases/createProjectStatus";
import * as editProjectStatus from "./useCases/editProjectStatus";
import * as retrieveProjectStatuses from "./useCases/retrieveProjectStatuses";
import * as removeProjectStatus from "./useCases/removeProjectStatus";

enum UseCases {
  createProjectStatus = "createProjectStatus",
  editProjectStatus = "editProjectStatus",
  retrieveProjectStatuses = "retrieveProjectStatuses",
  removeProjectStatus = "removeProjectStatus",
}

interface Core {
  [UseCases.createProjectStatus]: createProjectStatus.Interactor;
  [UseCases.editProjectStatus]: editProjectStatus.Interactor;
  [UseCases.retrieveProjectStatuses]: retrieveProjectStatuses.Interactor;
  [UseCases.removeProjectStatus]: removeProjectStatus.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.createProjectStatus]: createProjectStatus.createInteractor(
      dependencies.repository,
    ),
    [UseCases.editProjectStatus]: editProjectStatus.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectStatuses]:
      retrieveProjectStatuses.createInteractor(dependencies.repository),
    [UseCases.removeProjectStatus]: removeProjectStatus.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
